<template>
  <div class="c-link-list__item">
    <sc-link
      v-if="fields && fields.link"
      :field="fields.link"
      :rel="isExternal ? 'noopener noreferrer' : null"
      class="c-link-list__link"
      :class="fields.link.value.class"
    />
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Footer-NavList-Link',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    isExternal() {
      return (
        this.fields?.link?.value?.linktype === 'external' &&
        !this.fields?.link?.value?.href.includes('https://learn.cisecurity.org') &&
        !this.fields?.link?.value?.href.includes('https://workbench.cisecurity.org')
      );
    }
  }
};
</script>

<style lang="scss">
.c-footer__nav .c-nav__list .c-link-list__link {
  @include font-styles('Arial', 1.6rem, 400, normal, 2.2rem, 0, $white);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  a {
    color: $white;
  }
}
</style>
